<template>
<admin-template subtitle="Companies" :headerButton="getHeaderButton"
  @onButtonClicked="onCreateCompany">
  <dropdown-modal :title="this.$t('jobs.invitationEmail')" :active.sync="modalActive">
    <p>{{this.$t('jobs.invitationEmailSent')}}</p>
  </dropdown-modal>
  <dropdown-modal :title="this.$t('common.confirmAction')" :active.sync="modal">
    <p>{{getTitle}}</p>
    <div class="modal-button">
      <button class="button is-primary" @click="confirmHandler"><p v-if="!actionLoading">{{this.$t('common.confirm')}}</p> <spinner v-else></spinner></button>
    </div>
  </dropdown-modal>
<sidebar-modal
  :active.sync="showSidebar"
  :title="sidebarTitle"
  :button="sidebarButton"
  :loading="sidebarLoading"
  :error.sync="sidebarError"
  @action="onSidebarAction">
  <component v-bind:is="sidebarComponent" :bioError="bioError" :emailError="emailError" :jobBoardError="jobBoardError"></component>
</sidebar-modal>

<div v-if="getJobBoardOwnerCheck">
<div class="columns is-multiline  is-desktop is-mobile">
  <div class="column is-12-mobile is-12-tablet is-4-desktop is-4-widescreen is-4-fullhd">
    <companies-nav marginTop="24px" marginBottom="0px" :active="activeJobNav" v-on:active="onActiveJobNav"></companies-nav>
  </div>
  <div class="column is-12-mobile is-12-tablet is-4-desktop is-4-widescreen is-4-fullhd"></div>
  <div class="column is-12-mobile is-12-tablet is-4-desktop is-4-widescreen is-4-fullhd">
<!--    <safe-area top="24px"></safe-area>-->
<!--    <div class=" is-grouped">-->
<!--      <label for="">Select Job Board</label>-->

<!--      <div class="width-100 select ">-->
<!--        <select class="width-100 bold" v-model="selectJobBoard"  >-->
<!--          <option v-for="boards in jobBoards" :key="boards.id">{{boards.name}}</option>-->
<!--        </select>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</div>
  <div class="visible-text">
<!--    <strong class="content-title" >{{this.$t('common.visible')}}</strong>-->
  </div>
  <div class="companies"  v-if="activeJobNav === 'Active'">
    <div v-if="activeCompanies.length > 0 && !activeCompaniesLoading">
      <row-card v-for="company in activeCompanies" :key="company.id" class="company"
                :imageUrl="companyImageActive(company)"
                :leftTitle="company.name"
                :leftSubtitle="company.domain"
                @click="companyClicked(company)"
                :removeCompany="true"
                :companyStatus="statusCheck(company)"
                :toggleCompanyHandler="toggleCompanyHandler"
                :data="company"

      >
      </row-card>
    </div>
    <row-skeleton v-else-if="activeCompaniesLoading"></row-skeleton>
    <empty-state v-else title="No Companies" icon="empty-state-eyes" >
      <template slot="content">No companies to see here. Let’s create and onboard some companies and hiring teams.</template>
    </empty-state>
  </div>
  <div v-else>
    <div v-if="requestedCompanies.length > 0 && !requestedCompaniesLoading">
      <request-companies-card v-for="company in requestedCompanies"
                              :key="company.id+company.name" :imageUrl="companyImageActive(company)"
                              :leftTitle="getHirerName(company)"
                              :rightTitle="company.name"
                              :leftSubtitle="getHirerEmail(company)"
                              :boardId="company.boardId"
                              :companyId="company.id"
                              :companyHandler="companyHandler"
                              :boardName="company.boardName"
                              :company="company"
      >
      </request-companies-card>
    </div>
    <row-skeleton v-else-if="requestedCompaniesLoading"></row-skeleton>
    <empty-state v-else title="No Companies Request" icon="empty-state-eyes" >
      <template slot="content">No companies to see here. Let’s create and onboard some companies and hiring teams.</template>
    </empty-state>
  </div>
</div>
  <div v-else>
    <div class="companies"  v-if="activeJobNav === 'Active'">
      <div v-if="companies.length > 0 && !companiesLoading">
        <row-card v-for="company in companies" :key="company.id" class="company"
                  :imageUrl="companyImage(company)"
                  :leftTitle="company.name"
                  :leftSubtitle="company.domain"
                  @click="companyClicked(company)">
        </row-card>
      </div>
      <row-skeleton v-else-if="companiesLoading"></row-skeleton>
      <empty-state v-else title="No Companies" icon="empty-state-eyes" >
        <template slot="content">No companies to see here. Let’s create and onboard some companies and hiring teams.</template>
      </empty-state>
    </div>
  </div>
</admin-template>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import AdminTemplate from './admin-sub'
import RowCard from '@/components/general/row-card'
import SidebarModal from '@/components/sidebar-modal'
import CompanyForm from '@/components/admin/companies/company-form'
import EmptyState from '@/components/general/empty-state'
import InviteCompanyForm from '@/components/admin/companies/invite-company-form'
import Validators from '@/helpers/validators'
import DropdownModal from '@/components/dropdown-modal'
import CompaniesNav from '@/components/admin/companies/companies-nav'
import RequestCompaniesCard from '../../components/admin/companies/request-companies-card'
import RowSkeleton from '@/components/general/row-skeleton'
import Spinner from 'vue-simple-spinner'
import Column from '../../components/general/column'
import SafeArea from '../../components/safe-area'

import Jobs from '../../api/jobs'

const EditCompanyForm = CompanyForm

export default {
  components: {
    RowSkeleton,
    AdminTemplate,
    RowCard,
    SidebarModal,
    CompanyForm,
    EditCompanyForm,
    EmptyState,
    InviteCompanyForm,
    DropdownModal,
    CompaniesNav,
    RequestCompaniesCard,
    Spinner,
    Column,
    SafeArea
  },
  methods: {
    ...mapActions('adminCompanies', [
      'getAll',
      'getRequestedCompanies',
      'getAllCompanies', 'companyAction', 'toggleCompany'
    ]),
    ...mapActions('companyForm', [
      'createNewCompany',
      'updateCompany',
      'inviteCompany'
    ]),
    ...mapActions('jobs', ['getJobBoards']),
    ...mapMutations('companyForm', {
      clearCompanyForm: 'clear',
      loadCompanyForm: 'loadFromCompany',
      clearInviteCompanyForm: 'clearInviteCompanyForm',
      setBioError: 'setBioError',
      setCompanyDomainError: 'setCompanyDomainError',
      setCompanyNameError: 'setCompanyNameError'
    }),
    ...mapMutations('adminCompanies', ['setModalActive', 'setIndicator', 'setJobBoardIfForAdminCom']),
    onActiveJobNav (active) {
      this.activeJobNav = active
    },
    onCreateCompany () {
      this.clearCompanyForm()
      this.clearInviteCompanyForm()
      this.jobBoardError = null
      this.emailError = null
      if (this.getJobBoardOwnerCheck) {
        this.sidebarComponent = 'InviteCompanyForm'
        this.sidebarTitle = 'Invite company'
        this.sidebarButton = 'Invite Company'
        this.showSidebar = true
      } else {
        this.sidebarComponent = 'CompanyForm'
        this.sidebarTitle = 'New company'
        this.sidebarButton = 'Create Company'
        this.showSidebar = true
      }
    },
    validations () {
      if (this.companyName.length === 0) {
        this.setCompanyNameError('Company Name is required')
        return false
      } else if (this.companyDomain.length === 0) {
        this.setCompanyDomainError('Company domain is required')
        return false
      } else if (this.bio.length === 0) {
        this.setBioError('Bio is required')
        return false
      } else if (this.bio.length < 50) {
        this.setBioError('Minimum 50 characters required')
        return false
      }
      return true
    },
    async onSidebarAction () {
      switch (this.sidebarComponent) {
        case 'CompanyForm': {
          const bioValidation = this.validations()
          if (!bioValidation) {
            return false
          }
          this.sidebarLoading = true
          try {
            await this.createNewCompany()
            this.showSidebar = false
          } catch (error) {
            this.sidebarError = error.message
          }
          this.sidebarLoading = false
          break
        }
        case 'EditCompanyForm': {
          const bioValidation = this.validations()
          if (!bioValidation) {
            return false
          }
          this.sidebarLoading = true
          try {
            await this.updateCompany()
            this.showSidebar = false
          } catch (error) {
            this.sidebarError = error.message
          }
          this.sidebarLoading = false
          break
        }
        case 'InviteCompanyForm': {
          this.sidebarLoading = true
          try {
            if (!this.formSelectedJobBoard) {
              this.jobBoardError = 'Job board is required'
              this.sidebarLoading = false
              return
            } else if (!Validators.email(this.formEmail)) {
              this.jobBoardError = null
              this.emailError = this.$t('login.emailError')
              this.sidebarLoading = false
              return
            }
            this.emailError = null
            this.showSidebar = false
            this.modalActive = true
            await this.inviteCompany()
          } catch (error) {
            this.sidebarError = error.message
          }
          this.sidebarLoading = false
          break
        }
      }
    },
    companyClicked (company) {
      if (this.getJobBoardOwnerCheck) {
        return false
      }
      this.loadCompanyForm(company)
      this.sidebarComponent = 'EditCompanyForm'
      this.sidebarTitle = 'Edit company'
      this.sidebarButton = 'Save Company'
      this.showSidebar = true
    },
    getHirerName (company) {
      // if (company.hirerFirstName && company.hirerLastName) {
      //   return `${company.hirerFirstName} ${company.hirerLastName}`
      // } else if (company.hirerFirstName) {
      //   return company.hirerFirstName
      // } else if (company.hirerLastName) {
      //   return company.hirerLastName
      // }
      return company.name || ''
    },
    getHirerEmail (company) {
      return company.hirerEmail ? company.hirerEmail : ''
    },
    companyImage (company) {
      return company.imageUrl || `/api/identicons/${company.id}`
    },
    companyImageActive (company) {
      return company.image || `/api/identicons/${company.id}`
    },
    async confirmHandler () {
      await this.companyAction({
        boardId: this.selectedCompany.boardId,
        companyId: this.selectedCompany.companyId
      })
    },
    companyHandler (indicator, selectedCompany) {
      this.setIndicator(indicator)
      this.setModalActive(true)
      this.selectedCompany = selectedCompany
    },
    toggleCompanyHandler (value, data) {
      this.toggleCompany({value, data})
    },
    statusCheck (company) {
      if (company.hasOwnProperty('status') && company.status !== 5) {
        return true
      }
      return false
    }
  },
  computed: {
    ...mapState('jobs', ['jobBoards']),
    ...mapState('adminCompanies', [
      'companies',
      'requestedCompanies',
      'activeCompanies',
      'companiesLoading',
      'requestedCompaniesLoading',
      'activeCompaniesLoading', 'actionLoading', 'indicator'
    ]),
    ...mapState('adminCompanies', {
      actionModal: 'modalActive'
    }),
    ...mapState('users', [
      'user'
    ]),
    ...mapState('companyForm', {
      formEmail: 'inviteCompanyEmail',
      formSelectedJobBoard: 'selectedJobBoard',
      bio: 'bio',
      companyName: 'name',
      companyDomain: 'domain',
      bioError: 'bioError',
      companyNameError: 'companyNameError',
      companyDomainError: 'companyDomainError'
    }),
    ...mapState('jobs', {
      isJobBoardOwner: 'isJobBoardOwner', jobBoards: 'jobBoards'
    }),

    getHeaderButton () {
      try {
        return this.user.profile === 'jobboardowner' ? this.$t('jobs.inviteCompany') : this.$t('jobs.createCompany')
      } catch (e) {
        return ''
      }
    },
    getJobBoardOwnerCheck () {
      return this.user.profile === 'jobboardowner'
    },
    modal: {
      get () { return this.actionModal },
      set (value) { this.setModalActive(value) }
    },
    getTitle () {
      return this.indicator === 'approve-company' ? this.$t('common.confirmApprove') : this.$t('common.confirmReject')
    },
    selectJobBoard: {
      get () { return this.selectedJobBoard },
      set (value) { this.selectedJobBoard = value }
    }
  },
  async mounted () {
    this.getAll()

    const boards = await Jobs.getJobBoards()
    if (boards.length > 0) {
      this.setJobBoardIfForAdminCom(boards[0].id)
      this.getAllCompanies(boards[0].id)
    }
  },
  data () {
    return {
      showSidebar: false,
      sidebarComponent: '',
      sidebarTitle: '',
      sidebarButton: '',
      sidebarLoading: false,
      sidebarError: null,
      emailError: null,
      jobBoardError: null,
      modalActive: false,
      activeJobNav: 'Active',
      selectedCompany: null,
      selectedJobBoard: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.companies {
  margin-top: 0.5rem;
}

.visible-text{
  display: flex;
  justify-content: flex-end;
  padding-right: 24px;
}

.company:hover {
  cursor: pointer;
  background-color: $hover-background;
}

.company:not(:first-child) {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.company:not(:last-child) {
  border-bottom: 0;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

.approve{
  color: #53c8f0 ;
}
.reject{
  color:#d65861
}
.rightSubtitle{
  display: flex; justify-content: flex-end;
  margin-top: 10px;
}
.modal-button{
  display: flex;
  justify-content: flex-end;
}
.width-100{
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/pages/admin/companies.vue